// Dummy interface with the bare minimum functionality until LiveInputs is ported to TS fully
export interface LiveInputs {
  on: (
    event: string,
    selector: string,
    callback: (event: Event) => void
  ) => void
  off: (
    event: string,
    selector: string,
    callback: (event: Event) => void
  ) => void
}

export interface LiveInputsPostLinkInterface {
  teardown(): void
}

export type SaveButtonState =
  | 'disabled'
  | 'hidden'
  | 'save'
  | 'saving'
  | 'saved'
  | 'failed'

export const WorkflowProgressStatuses = {
  INITIAL: 'initial',
  WAITING: 'waiting',
  COMPLETED: 'completed',
} as const

export type WorkflowProgressStatus =
  typeof WorkflowProgressStatuses[keyof typeof WorkflowProgressStatuses]

export const SaveChangesStatuses = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  ERROR: 'error',
} as const

export type SaveChangesStatus =
  typeof SaveChangesStatuses[keyof typeof SaveChangesStatuses]
